import React from "react";

const HeroDmsSection = ({ heroContent }) => {
  return (
    <div
      className="hero-section"
      style={{ backgroundImage: `url("${heroContent.backgroundImage}")` }}
    >
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1 className="fw-bold">{heroContent.title}</h1>
        <p className="lead">{heroContent.description}</p>
      </div>
    </div>
  );
};

export default HeroDmsSection;
